/**
 * TrackerPendingCard — neutral placeholder for a view a tracker does not have
 * (Tres Commas' Flow Optimizer until Phase 2, or Tres Commas on a deployment
 * without its keys). Rendered INSTEAD of the view, so nothing is requested on
 * that tracker's behalf.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Clock } from 'lucide-react';
import { trackerLabel, type TrackerId } from '@trafficpulse/shared';

import { Card, CardContent } from '@/components/ui';

interface TrackerPendingCardProps {
  tracker: TrackerId;
  /** What is missing, after the tracker name. */
  message: string;
}

export const TrackerPendingCard: FC<TrackerPendingCardProps> = ({ tracker, message }) => (
  <Card data-tracker={tracker}>
    <CardContent className="py-8 text-center text-muted-foreground">
      <Clock className="mx-auto mb-4 h-12 w-12 opacity-50" aria-hidden />
      <p>{`${trackerLabel(tracker)} — ${message}`}</p>
    </CardContent>
  </Card>
);

export default TrackerPendingCard;
